import { Delete16, Download16 } from "@carbon/icons-react";
import { Button, DropdownSkeleton, FormGroup, FormLabel, Table, TableBody, TableCell, TableContainer, TableHead, TableHeader, TableRow, TextInputSkeleton } from "carbon-components-react";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { registry } from "../../helpers/api/api";
import { apioperation, entitiesLabels, getError, Megabyte } from "../../helpers/Constants";
import { NoRecordsPlaceholder } from "../../helpers/jsonschemaform/DataTableExtention";
import showNotification from "../../helpers/notification/BaseNotification";
import FileDownLoadButton from "./FileDownloadButton";
import FileUpload from "./FileUpload";
import { Online } from "./OnLineOffLine";

export const attachmentTablePrivacyText = "(It is forbidden to upload photos which show people's faces. It is also forbidden to upload photos on which it is possible to recognize specific people)"
export default class AttachmentTable extends Component {
	constructor(props) {
		super(props);
		this.state = {
			appStatus: null,
		};
	}

	componentDidMount() {
		this.getStatus();
	}

	getStatus = () => {
		registry
			.getAll("status")
			.then((response) => {
				const { data } = response;
				this.setState({ appStatus: data });
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.STATUS, apioperation.GET));
			});
	};

	remove = (id) => this.props.onDeleteFile(id);

	onUpload = (fileIdentifier, fileName, fileType, size) => {
		const documentType = this.props.documentType || null; //RITM1405215
		documentType !== null ? this.props.onUploadFIle(fileIdentifier, fileName, fileType, size, documentType) : this.props.onUploadFIle(fileIdentifier, fileName, fileType, size); //RITM1405215
	};

	sumAttachmentSize = (onlyImage = false) => {
		let sum = 0
		if(onlyImage) sum = this.props.items?.filter(a => a.attachment.contentType.includes('image') && a.attachment.size).reduce((sum, item) => sum + +item.attachment.size, 0);
		else sum = this.props.items?.reduce((prevSum, item) => prevSum + +item.attachment.size, 0);
		return sum;
	};

	renderUploadFile() {
		if (!this.props.model) return <TextInputSkeleton hideLabel />;
		if (!this.state.appStatus) return <DropdownSkeleton />;
		const canUploadOtherDocument = this.props.maxUploadDocument == null ? true : (this.props.items?.length ?? 0) < this.props.maxUploadDocument;
		return (
			canUploadOtherDocument &&
			!this.props.isDisabled && (
				<FileUpload
					disabled={!this.props.model}
					singleFileSizeLimit={this.props.customSingleFileSizeLimit ?? Megabyte.THREEMEGABYTE}
					accept={this.props.acceptedFile}
					customMainDescription={this.props.customMainDescription ?? attachmentTablePrivacyText}
					acceptDescription={this.props.customDescription ?? "only files at 3mb or less"}
					maxSingleSizeErrorLabel={this.props.maxSingleSizeErrorLabel ?? entitiesLabels.THREEMEGABYTEMAXSIZE}
					sumAttachmentSize={this.sumAttachmentSize(false)}
					sumImageAttachmentSize={this.sumAttachmentSize(true)}
					totalFilesSizeLimit={this.props.customTotalFilesSizeLimit ?? Megabyte.TENMEGABYTE}
					maxTotalSizeErrorLabel={this.props.maxTotalSizeErrorLabel ?? entitiesLabels.TENMEGABYTEMAXSIZE}
					Container="saipem"
					StoragePath={this.props.storagePath}
					onUpload={this.onUpload}
				/>	
			)
		);
	}

	render() {
		const isDocumentTypeSpecified = this.props.items?.some((item) => item.documentType);
		return (
			<>
				<div className="bx--col--md-4 bx--col-lg-6">
					<FormGroup legendText="">{this.renderUploadFile()}</FormGroup>
				</div>

				<div className="bx--col--md-12 bx--col-lg-12 layout-elements-table">
					<FormLabel className="some-class">Attachments</FormLabel>
					{!this.props.model ? (
						<TextInputSkeleton hideLabel />
					) : !this.state.appStatus ? (
						<DropdownSkeleton />
					) : (
						<TableContainer className="bx--grid--full-width">
							<Table>
								<TableHead className="colorgray">
									<TableRow>
										<TableHeader>Name</TableHeader>
										{isDocumentTypeSpecified && <TableHeader className="align-center">Document Type</TableHeader>}
										<TableHeader className="align-center">Actions</TableHeader>
									</TableRow>
								</TableHead>
								<TableBody>
									{this.props.items == null || this.props.items.length === 0 ? (
										<NoRecordsPlaceholder labelText="No Records" colSpan={3} />
									) : (
										this.props.items.map((item) => (
											<TableRow key={`row_${item.id}`}>
												<TableCell key={`cell_1_${item.id}`}>{item.attachment?.name}</TableCell>
												{isDocumentTypeSpecified && <TableCell key={`doc_Type_${item.id}`}>{item.attachment?.documentType ?? ""}</TableCell>}
												<TableCell key={`action-${item.id}`} className="tableActions align-center">
													<div>
														<Online>
															<FileDownLoadButton
																onError={(error) => showNotification.error(getError(error, null, apioperation.DOWNLOAD))}
																size="small"
																renderIcon={Download16}
																iconDescription="Download"
																kind="ghost"
																apiUrl={this.props.apiDownloadUrl + encodeURIComponent(item.attachment?.fileIdentifier)} //RITM1094125
																fileName={item.attachment?.name}
																onDownLoadStart={() => {}}
																onDownLoadEnd={() => {}}
															/>
															<Button onClick={() => this.remove(item.id)} size="small" renderIcon={Delete16} iconDescription="Delete" kind="ghost" disabled={this.props.isDisabled} />
														</Online>
													</div>
												</TableCell>
											</TableRow>
										))
									)}
								</TableBody>
							</Table>
						</TableContainer>
					)}
				</div>
			</>
		);
	}
}

AttachmentTable.propTypes = {
	model: PropTypes.object,
	items: PropTypes.array,
	apiDownloadUrl: PropTypes.string,
	isDisabled: PropTypes.bool,
};
